export const PROOF_OF_ADDRESS_FIELDS = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  STREET: "street",
  CITY: "city",
  PARISH: "parish",
  STATE: "state",
  POSTAL_CODE: "postalCode",
  COUNTRY: "country",
  ISSUE_DATE: "issueDate"
};
